import React, { FunctionComponent, ReactNode } from 'react';

import './PageHeader.scss';

interface IPageHeaderProps {
    right?: ReactNode;
    title?: ReactNode;
    top?: ReactNode;
}

export const PageHeader: FunctionComponent<IPageHeaderProps> = (props) => (
    <div className="pageHeader">
        {props.top && (
            <div className="pageHeader_top">{props.top}</div>
        )}
        <div className="pageHeader_titleWrapper">
            <h1 className="pageHeader_title ellipsis">{props.title}</h1>
            {props.right && (
                <div className="pageHeader_right">{props.right}</div>
            )}
        </div>

    </div>
);